module.exports = __webpack_public_path__ + "assets/img/ic-reply-hover.229cf3de.svg";